import IGlassArea from 'components/interfaces/IGlassArea';
import IWall from 'components/interfaces/IWall';
import { hasElementWall } from 'components/configurator/types/wallTypes';

const calculateManualGlassLastGlassLength = (
  glassArea: IGlassArea,
  glassAreaLength: number,
  wall?: IWall
): number => {
  const lastGlassIndex = glassArea.glasses.length - 1;
  const glassSpacing = window.CommonFunctions.GetGlassGlassSpacing();

  return glassArea.glasses.reduce((current, glass, index) => {
    let spacing = 0;
    if (wall && !hasElementWall(wall)) {
      spacing = glassSpacing;
    }

    const currentGlassSpacing = index === 0 ? 0 : spacing;

    if (index === lastGlassIndex) {
      return current - currentGlassSpacing;
    }

    return current - glass.width - currentGlassSpacing;
  }, glassAreaLength);
};

export default calculateManualGlassLastGlassLength;
